import React, { useState, useCallback } from 'react';
import styled, { css } from '../../../../../styled';
import ItemCartBtn from './ItemCartBtn';
import { Chevron } from '../../../../icons/outline';
import PrivateDropdown from './ItemPrivateDropdown';
const ProductRowWrapper = styled.div `
  display: flex;
  height: 2.5rem;
  align-items: center;
`;
const PaddingWrapper = styled.div `
  padding: 0.5rem 1.5rem 0.25rem;
  text-align: left;
  ${props => props.focus &&
    css `
      background-color: ${({ theme }) => theme.colors.PRIMARY_200};
    `};
`;
const Content = styled.div `
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.57;
  margin-right: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: ${({ theme }) => theme.colors.INK_800};
`;
const ProductImage = styled.div `
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 0.5rem;
  border: ${({ theme }) => `0.0625rem solid ${theme.colors.INK_200}`};
  border-radius: 0.375rem;
  background-image: ${({ backgroundImage }) => backgroundImage && `url(${backgroundImage})`};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;
const VariationCartBtnWrapper = styled.div `
  position: absolute;
  bottom: -0.0625rem;
  right: 0;
`;
const VariationsBtn = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  :hover {
    cursor: pointer;
  }
  > svg {
    transition: transform 0.3s ease-in-out;
  }
`;
const VariationWrapper = styled.div `
  position: relative;
  margin-top: 0.25rem;
  padding: 0.0625rem 0 0 3rem;
`;
const ProductRow = ({ imageUrl, productName, variationToDisplay, onCartBtnClick, renderAddInfo, }) => {
    const [isOpenVariation, setIsOpenVariation] = useState(false);
    const [variationSelected, setVariationSelected] = useState([]);
    const handleCartBtnClick = useCallback(() => {
        if (!variationToDisplay)
            onCartBtnClick();
        if (variationToDisplay &&
            variationSelected &&
            variationSelected.filter(variation => !!variation).length ===
                variationToDisplay.length) {
            onCartBtnClick(variationSelected);
            setVariationSelected([]);
        }
    }, [
        onCartBtnClick,
        variationToDisplay,
        variationSelected,
        setVariationSelected,
    ]);
    const handleDropdownChange = useCallback((value, index) => {
        setVariationSelected(prevSelected => {
            const newVariation = [...prevSelected];
            const newValue = value[0];
            newVariation[index] = newValue;
            return newVariation;
        });
    }, []);
    const handleOpenVariationClick = useCallback(() => {
        setIsOpenVariation(prev => !prev);
    }, []);
    return (React.createElement(PaddingWrapper, { focus: isOpenVariation },
        React.createElement(ProductRowWrapper, null,
            React.createElement(ProductImage, { backgroundImage: imageUrl }),
            React.createElement(Content, null, productName),
            variationToDisplay ? (React.createElement(VariationsBtn, { onClick: handleOpenVariationClick },
                React.createElement(Chevron, { size: "MEDIUM", color: "INK_600", position: isOpenVariation ? 'TOP' : 'BOTTOM' }))) : (React.createElement(ItemCartBtn, { onClickHandler: handleCartBtnClick }))),
        isOpenVariation && (React.createElement(VariationWrapper, null,
            variationToDisplay &&
                variationToDisplay.map((variation, index) => {
                    const { variationLabel, variationOptions } = variation;
                    const optionsProps = variationOptions.map(option => ({
                        value: option,
                        key: option,
                        label: option,
                        disabled: false,
                    }));
                    return (React.createElement(PrivateDropdown, { key: variationLabel, value: variationSelected[index] ? [variationSelected[index]] : [], options: optionsProps, onChange: value => handleDropdownChange(value, index), placeHolder: variationLabel }));
                }),
            React.createElement(VariationCartBtnWrapper, null,
                React.createElement(ItemCartBtn, { onClickHandler: handleCartBtnClick })))),
        renderAddInfo && renderAddInfo()));
};
export default React.memo(ProductRow);
//# sourceMappingURL=index.js.map